import { FC } from 'react';
import stepIcon from '../../../Assets/StepIcons/Delay.png';
import { NodeLibraryListItem } from '../../Components/NodeLibraryListItem';
import { DELAY_NODE_DESCRIPTION, NodeTypes } from '../../utils';

export const DelayNodeLibraryListItem: FC = () => {
    return <NodeLibraryListItem label='Delay' description={DELAY_NODE_DESCRIPTION} nodeType={NodeTypes.DELAY} imgPath={stepIcon} />
}